////////運輸方式非必填 為了讓使用者可以清空運輸方式 要在運輸方式的選項加入clear
const fourThreeSchema = {
  title:
    "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
  addAPI: "cat4_3AddEmissionActivityAPI",
  cat: "cat4_3",
  ////////正常的EA
  normal: {
    title:
      "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
    addAPI: "cat4_3AddEmissionActivityAPI",
    cat: "cat4_3",
    name: "normalField",
    EATitle: "Emission Activity",
    fields: [
      {
        key: "itemName",
        level: 1,
        type: "input",
        label: "Service Provider / Waste Name",
        resetOnChange: false,
        required: true,
      },
      {
        key: "activityId",
        level: 1,
        type: "select",
        label: "Waste Disposal Method",
        optionsAPI: "disposalServicesWasteDisposalMethodAPI",
        resetOnChange: false,
        required: true,
      },
      //////// Method of Calculation
      {
        key: "calculationId",
        level: 1,
        type: "select",
        label: "Method of Calculation",
        optionsParamFrom: { value: "4_3" },
        optionsAPI: "cat4Calculation",
        resetOnChange: false,
        required: true,
      },
    ],
  },
  ////////交通運輸EA
  tran: {
    title:
      "4_3 Disposal Services (of solid or liquid waste) Used by an Organization",
    addAPI: "cat4_3AddEmissionActivityAPI",
    cat: "cat4_3",
    name: "tranField",
    EATitle: "Transportation Emission Activity",
    fields: [
      //////// 是否有運輸
      {
        key: "isTransport",
        level: 1,
        type: "select",
        optionsAPI: "isTransport",
        width: "732px",
        label: "Is there transportation ?",
        required: true,
        longInputWrap: true,
      },
      //////// Transportation Mode
      {
        key: "transportActivityId",
        level: 2,
        type: "select",
        optionsAPI: "disposalServicesTransportationMethodAPI",
        label: "Transportation Mode",
        optionsParamFrom: { level: 1, key: "isTransport" },
        showIf: {
          level: 1,
          key: "isTransport",
          eq: true,
        },
        required: true,
      },
      //////// Method of Calculation ( 前端寫死 為了不清空其他的 加入temp)
      {
        key: "tempCalculationId",
        level: 3,
        type: "select",
        optionsAPI: "cat4_3CalculationAPI",
        label: "Method of Calculation",
        optionsParamFrom: { level: 2, key: "tempCalculationId" },
        showIf: {
          all: [
            { level: 1, key: "isTransport", eq: true },
            { level: 2, key: "transportActivityId", notEmpty: true },
          ],
        },
        autoFillNum: 0,
        resetOnChange: false,
        required: true,
      },
      //////// Origin
      {
        key: "origin",
        level: 4,
        type: "input",
        label: "Origin",
        showIf: {
          all: [
            { level: 1, key: "isTransport", eq: true },
            { level: 1, key: "isTransport", eq: true },
          ],
        },
      },
      //////// Destination
      {
        key: "destination",
        level: 4,
        type: "input",
        label: "Destination",
        showIf: {
          all: [
            { level: 1, key: "isTransport", eq: true },
            { level: 1, key: "isTransport", eq: true },
          ],
        },
      },
      //////// Distance
      {
        key: "distance",
        level: 4,
        type: "input",
        label: "Distance (Unit: km)",
        showIf: {
          all: [
            { level: 1, key: "isTransport", eq: true },
            { level: 1, key: "isTransport", eq: true },
          ],
        },
        placeholder: 0,
        required: true,
      },
    ],
  },
};

export default fourThreeSchema;
